/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alert-label-container[_ngcontent-%COMP%]{font-size:1.4rem;font-weight:700;padding:4px 10px;height:24px;box-sizing:border-box}.alert-label-container-line-one[_ngcontent-%COMP%]{font-size:1.4rem;font-weight:700;padding:4px 8px 1px;height:20px;box-sizing:border-box}.alert-label-container-line-two[_ngcontent-%COMP%]{font-size:1.4rem;font-weight:700;padding:1px 8px 4px;height:20px;box-sizing:border-box}"];
export { styles as styles };
